"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.FloorPlanSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var FloorPlanSVG = function FloorPlanSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("path", {
    stroke: "none",
    d: "M4 30h3a1 1 0 000-2H4V15h10v2a1 1 0 002 0V8a1 1 0 00-2 0v5H4V4h24v9h-7a1 1 0 000 2h7v13H16v-5h3a1 1 0 000-2h-4a1 1 0 00-1 1v7a1 1 0 001 1h13a2 2 0 002-2V4a2 2 0 00-2-2H4a2 2 0 00-2 2v24a2 2 0 002 2z"
  }));
};
exports.FloorPlanSVG = FloorPlanSVG;
FloorPlanSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(FloorPlanSVG);
exports.default = _default;